import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const RoutingTab = () => {

const [showExtraEntity, setShowExtraEntity] = useState(false);
const [showMasterShipper, setShowMasterShipper] = useState(false);
const [showCustomBroker, setShowCustomBroker] = useState(false);
const [showSecondNotify, setShowSecondNotify] = useState(false);
const [showThirdNotify, setShowThirdNotify] = useState(false);
const [showTransporter, setShowTransporter] = useState(false);
const [showShipTo, setShowShipTo] = useState(false);
const [showBookingParty, setShowBookingParty] = useState(false);
const [showSeller, setShowSeller] = useState(false);
const [showImporter, setShowImporter] = useState(false);
const [showBuyer, setShowBuyer] = useState(false);
const [showCertifiter, setShowCertifiter] = useState(false);

useEffect(() => {
if (showMasterShipper==true || showCustomBroker == true || showSecondNotify == true || showThirdNotify == true ||
showTransporter == true ||
showShipTo == true || showBookingParty == true || showSeller == true || showImporter == true || showBuyer == true) {
setShowExtraEntity(true);
} else {
setShowExtraEntity(false);
}
}, [showMasterShipper, showCustomBroker, showSecondNotify, showThirdNotify, showTransporter, showShipTo,
showBookingParty, showSeller,
showImporter, showBuyer])

const shipperOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">

            <div className="py-2">
                <div className="row">

                <div className="col-md-6">
                            <label className="form-label   mb-0">Total Due</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                <div className="col-md-6">
                            <label className="form-label   mb-0">Balance</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                <div className="col-md-6">
                            <label className="form-label   mb-0">Payment Mode</label>
                            <Select className='mt-2 custom-selector w-100' />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Credit Available</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Receipt Number</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Receipt Date</label>
                            <input type="date" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Amount Received</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">TDS Amount</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Chq./Draft/Ref No.</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Chq./Draft/Ref Date </label>
                            <input type="date" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Bank Name</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Paid by</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label   mb-0">Remark</label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                </div>
            </div>

        </div>

        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>

        </div>
    </form>
</>
)
}

export default RoutingTab